import React from "react";
import ExternalLink from "../../common/ExternalLink";
import styles from "./applicationconditions.module.scss";

type Props = {
  requirements: string;
};
export const ApplicationConditions: React.FC<Props> = (props) => {
  const { requirements } = props;

  return (
    <div className={styles["project-details_application-conditions"]}>
      <p>
        <ExternalLink text={requirements} />
      </p>
    </div>
  );
};

export default ApplicationConditions;
